/**
 * iter274 — Traductions FR / DE des pages publiques de suivi.
 * Le choix de langue est local au navigateur du client : les liens déjà partagés
 * fonctionnent donc sans aucune modification côté garage.
 */
const STORE = "suivi-lang";

export const LANGS = ["fr", "de"];

export function langInitiale() {
  const sauve = localStorage.getItem(STORE);
  if (LANGS.includes(sauve)) return sauve;
  return String(navigator.language || "").toLowerCase().startsWith("de") ? "de" : "fr";
}

export function memoriseLang(lang) {
  localStorage.setItem(STORE, lang);
}

export const LOCALES = { fr: "fr-CH", de: "de-CH" };

export const ETAPES = {
  fr: ["Reçu", "Devis", "En travaux", "Travaux finis", "À récupérer"],
  de: ["Eingang", "Kostenvoranschlag", "In Arbeit", "Arbeiten erledigt", "Abholbereit"],
};

export const STATUTS = {
  fr: {
    cree: "Véhicule reçu",
    pris_en_charge: "Véhicule pris en charge",
    controle: "Véhicule contrôlé",
    devis_envoye: "Devis envoyé — en attente de votre accord",
    approbation: "Devis accepté",
    commencement: "En travaux",
    travaux_effectue: "Travaux finis",
    pret: "À récupérer",
    facture: "À récupérer",
    facturee: "Facturé",
    paye: "Terminé",
    annule: "Annulé",
    non_applicable: "Sans suite",
  },
  de: {
    cree: "Fahrzeug eingetroffen",
    pris_en_charge: "Fahrzeug übernommen",
    controle: "Fahrzeug geprüft",
    devis_envoye: "Kostenvoranschlag gesendet — wartet auf Ihre Zustimmung",
    approbation: "Kostenvoranschlag akzeptiert",
    commencement: "In Arbeit",
    travaux_effectue: "Arbeiten erledigt",
    pret: "Abholbereit",
    facture: "Abholbereit",
    facturee: "Verrechnet",
    paye: "Abgeschlossen",
    annule: "Storniert",
    non_applicable: "Ohne Folge",
  },
};

/** Libellés des références d'en-tête (clés de or_references.py). */
export const REFS = {
  de: {
    sinistre_numero: "Schadennummer",
    reference_vehicule: "Fahrzeugreferenz",
    no_autorisation: "Bewilligungsnummer",
    no_intervention: "Auftragsnummer",
    no_commande: "Bestellnummer",
    no_police: "Policennummer",
  },
};

const T = {
  fr: {
    titre: "Suivi de vos véhicules",
    lien_indisponible: "Lien indisponible",
    actualiser: "Actualiser",
    en_travaux: "en travaux",
    a_recuperer: "à récupérer",
    onglet_en_cours: "En cours",
    onglet_historique: "Historique",
    recherche: "Rechercher une plaque, un modèle, un n° de dossier…",
    vide_en_cours: "Aucun véhicule à l'atelier actuellement.",
    vide_historique: "Aucun dossier terminé sur les {mois} derniers mois.",
    dossier_cloture_le: "Dossier clôturé le",
    sans_plaque: "Sans plaque",
    dossier: "Dossier",
    depose_le: "Déposé le",
    rdv: "RDV",
    pret_depuis: "Prêt depuis",
    mise_a_jour: "Mise à jour",
    facture: "Facture",
    photos_vehicule: "Photos du véhicule",
    devis: "Devis",
    a_valider: "· à valider",
    vehicule_pret: "Votre véhicule est prêt — à récupérer",
    vehicule_enleve_le: "Véhicule enlevé le",
    vehicule_enleve: "Véhicule enlevé",
    annuler: "Annuler",
    devis_en_attente: "Devis en attente de votre accord",
    valider_devis: "Valider le devis",
    votre_autorisation: "Votre n° d'autorisation",
    vaut_accord: "— il vaut accord sur le devis",
    valider: "Valider",
    autorisation_ok: "N° d'autorisation enregistré",
    enregistrement_ko: "Enregistrement impossible",
    devis_valide_ok: "Merci, votre devis est validé",
    validation_ko: "Validation impossible",
    enlevement_ok: "Merci, enlèvement confirmé",
    enlevement_annule: "Enlèvement annulé",
    action_ko: "Action impossible",
    lien_invalide: "Lien de suivi invalide",
    // écrans mot de passe
    porte_titre: "Suivi protégé",
    porte_texte: "Saisissez le mot de passe communiqué par le garage.",
    porte_champ: "Mot de passe",
    porte_bouton: "Accéder au suivi",
    changer_titre: "Choisissez votre mot de passe",
    changer_texte: "Premier accès : remplacez le mot de passe communiqué par le garage.",
    changer_nouveau: "Nouveau mot de passe",
    changer_confirme: "Confirmer le mot de passe",
    changer_bouton: "Enregistrer",
    mdp_court: "6 caractères minimum",
    mdp_different: "Les deux mots de passe ne correspondent pas",
    mdp_incorrect: "Mot de passe incorrect",
    mdp_enregistre: "Mot de passe enregistré",
    // messagerie
    ecrire_garage: "Écrire au garage",
    discussion: "Discussion avec le garage",
    aucun_message: "Aucun message. Posez votre question, le garage vous répond ici.",
    votre_message: "Votre message…",
    piece_jointe: "Pièce jointe",
    a_envoyer: "À envoyer",
    image_illisible: "Image illisible",
    envoi_ko: "Envoi impossible",
  },
  de: {
    titre: "Verfolgung Ihrer Fahrzeuge",
    lien_indisponible: "Link nicht verfügbar",
    actualiser: "Aktualisieren",
    en_travaux: "in Arbeit",
    a_recuperer: "abholbereit",
    onglet_en_cours: "Laufend",
    onglet_historique: "Verlauf",
    recherche: "Kennzeichen, Modell oder Auftragsnummer suchen…",
    vide_en_cours: "Derzeit kein Fahrzeug in der Werkstatt.",
    vide_historique: "Kein abgeschlossener Auftrag in den letzten {mois} Monaten.",
    dossier_cloture_le: "Auftrag abgeschlossen am",
    sans_plaque: "Ohne Kennzeichen",
    dossier: "Auftrag",
    depose_le: "Abgegeben am",
    rdv: "Termin",
    pret_depuis: "Bereit seit",
    mise_a_jour: "Aktualisiert",
    facture: "Rechnung",
    photos_vehicule: "Fotos des Fahrzeugs",
    devis: "Kostenvoranschlag",
    a_valider: "· zu genehmigen",
    vehicule_pret: "Ihr Fahrzeug ist bereit — zur Abholung",
    vehicule_enleve_le: "Fahrzeug abgeholt am",
    vehicule_enleve: "Fahrzeug abgeholt",
    annuler: "Abbrechen",
    devis_en_attente: "Kostenvoranschlag wartet auf Ihre Zustimmung",
    valider_devis: "Kostenvoranschlag genehmigen",
    votre_autorisation: "Ihre Bewilligungsnummer",
    vaut_accord: "— gilt als Zustimmung zum Kostenvoranschlag",
    valider: "Bestätigen",
    autorisation_ok: "Bewilligungsnummer gespeichert",
    enregistrement_ko: "Speichern nicht möglich",
    devis_valide_ok: "Danke, Ihr Kostenvoranschlag ist genehmigt",
    validation_ko: "Genehmigung nicht möglich",
    enlevement_ok: "Danke, Abholung bestätigt",
    enlevement_annule: "Abholung widerrufen",
    action_ko: "Aktion nicht möglich",
    lien_invalide: "Ungültiger Verfolgungslink",
    porte_titre: "Geschützte Verfolgung",
    porte_texte: "Geben Sie das von der Garage mitgeteilte Passwort ein.",
    porte_champ: "Passwort",
    porte_bouton: "Zur Verfolgung",
    changer_titre: "Wählen Sie Ihr Passwort",
    changer_texte: "Erster Zugriff: Ersetzen Sie das von der Garage mitgeteilte Passwort.",
    changer_nouveau: "Neues Passwort",
    changer_confirme: "Passwort bestätigen",
    changer_bouton: "Speichern",
    mdp_court: "Mindestens 6 Zeichen",
    mdp_different: "Die beiden Passwörter stimmen nicht überein",
    mdp_incorrect: "Falsches Passwort",
    mdp_enregistre: "Passwort gespeichert",
    ecrire_garage: "Der Garage schreiben",
    discussion: "Konversation mit der Garage",
    aucun_message: "Noch keine Nachricht. Stellen Sie Ihre Frage, die Garage antwortet hier.",
    votre_message: "Ihre Nachricht…",
    piece_jointe: "Anhang",
    a_envoyer: "Zu senden",
    image_illisible: "Bild nicht lesbar",
    envoi_ko: "Senden nicht möglich",
  },
};

export function traducteur(lang) {
  const dico = T[lang] || T.fr;
  return (cle, vars) => {
    let txt = dico[cle] ?? T.fr[cle] ?? cle;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        txt = txt.replace(`{${k}}`, v);
      });
    }
    return txt;
  };
}

export function statutLabel(lang, statut, fallback) {
  return (STATUTS[lang] || STATUTS.fr)[statut] || fallback || statut || "";
}

export function refLabel(lang, ref) {
  if (lang === "de" && ref?.key && REFS.de[ref.key]) return REFS.de[ref.key];
  return ref?.label || "";
}
